export const BEFORE_PACKED_SHIPMENT_STATUSES = ['created', 'picking', 'picked'];

export const PACKED_SHIPMENT_STATUSES = ['packed'];

export const EDITABLE_SHIPMENT_STATUSES = [
  ...BEFORE_PACKED_SHIPMENT_STATUSES,
  ...PACKED_SHIPMENT_STATUSES,
];

export const PRINTABLE_INVOICE_STATUSES = [
  'packed',
  'ready_to_ship',
  'added_to_manifest',
  'dispatched',
  'delivered',
  'splitted',
  'return_acknowledged',
  'returned',
  'canceled',
];

export const REJECTED_SHIPMENT_LINE_STATUSES = [
  'reject_damaged',
  'reject_not_found',
];

export const getShipmentLineBadgeColor = status => {
  switch (status) {
    case 'created':
    case 'picking':
      return 'secondary';

    case 'picked':
      return 'success';

    case 'dispatched':
    case 'delivered':
      return 'info';

    case 'missing_product':
    case 'order_cancelled':
    case 'reject_not_found':
    case 'reject_damaged':
    case 'damaged':
    case 'lost':
    case 'returned':
      return 'danger';

    default:
      return 'secondary';
  }
};

export const getShipmentBadgeColor = status => {
  switch (status) {
    case 'created':
    case 'picking':
    case 'picked':
    case 'sidelined':
    case 'splitted':
      return 'secondary';

    case 'packed':
      return 'primary';

    case 'ready_to_ship':
    case 'added_to_manifest':
    case 'dispatched':
    case 'delivered':
      return 'info';

    case 'return_acknowledged':
    case 'returned':
    case 'canceled':
      return 'danger';

    default:
      return 'secondary';
  }
};
